<template>
  <div class="footer" ref="footer" id="home-footer">
    <div class="footer-top">
      <div class="content">
        <div class="left">
          <img :src="static_img_url+'pic/logo.png?v=' + $store.state.imgVersion" class="logo"/>
          <p class="p2">{{'重庆市渝北区金星科技大厦A区5楼512室' | dealLanguage('Room 512, 5th Floor, Block A, Jinxing Technology Building, Yubei District, Chongqing')}}</p>
          <p class="p2">{{'联系电话：023-67685030（重庆）' | dealLanguage('TEL：023-67685030(Chongqing)')}}</p>
        </div>
        <div class="center">
          <div class="link">
            <div class="link-title">{{'关于我们' | dealLanguage('ABOUT US')}}</div>
            <div class="link-list">
              <div><a :href="index2_path + '/Index/Index/companyInfo'" target="_blank">{{'关于动脉网' | dealLanguage('about vcbeat')}}</a></div>
              <div><a :href="index2_path + '/Index/Index/aboutUs'" target="_blank">{{'联系我们' | dealLanguage('contact us')}}</a></div>
              <div><a href="https://vcbeat.zhiye.com/Campus" target="_blank">{{'加入我们' | dealLanguage('join us')}}</a></div>
              <div><a href="https://support.qq.com/products/340682" target="_blank" rel="nofollow">{{'意见反馈' | dealLanguage('feedback')}}</a></div>
            </div>
          </div>
          <div class="link" v-if="btnList.length">
            <div class="link-title">{{'快捷入口' | dealLanguage('Quick entrance')}}</div>
            <div class="link-list">
              <div v-for="item,index in btnList" :key="index"><a @click="clickBanner(item, 'footer')">{{item.description}}</a></div>
            </div>
          </div>
        </div>
        <div class="right">
          <div>
            <p class="title">{{'联系我们' | dealLanguage('Contact Us')}}</p>
            <div class="ewm-item">
              <img :src="static_img_url + 'pic/jingwei.jpg?v=' + $store.state.imgVersion" />
              <p class="p1">{{'动脉网-经女士' | dealLanguage('VBEF-Mr.Weng')}}</p>
            </div>
            <!--<div class="ewm-item">
              <img :src="static_img_url + 'pic/xiaomeng.png?v=' + $store.state.imgVersion" />
              <p class="p1">动脉网-小萌</p>
            </div>-->
          </div>
          <div>
            <p class="title">{{'关注我们' | dealLanguage('Follow Us')}}</p>
            <div class="ewm-item">
              <img :src="static_img_url + 'pic/vbef-code.png?v=' + $store.state.imgVersion" />
              <p class="p1">{{'VBEF订阅号' | dealLanguage('VBEF-Official Account')}}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="inter-link" v-if="links.length">
        <p class="title">{{'友情链接' | dealLanguage('Friendly Links')}}</p>
        <div class="links">
          <a v-for="item,index in links" :key="index" :href="item.link_url" target="_blank">
            <img :src="item.img_path | logo_show" :alt="item.title">
          </a>
        </div>
      </div>
    </div>
    <div class="footer-bottom">
      <a href="http://beian.miit.gov.cn" target="_blank">© 动脉橙 渝ICP备18013108号</a>
      <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=50011202502165">
        <img :src="img_req_url + '/upload/vcbeat/public/images/pb-icon.png?v=' + $store.state.imgVersion" />
        渝公网安备 50011202502165号
      </a>
      <a href="javascript:void(0)" @click="certificate_model = true">互联网药品信息服务资格证书：（渝）-非经营性-2023-0083</a>
    </div>
    <Modal class="certificate-model" v-model="certificate_model" width="960" :footer-hide="true">
      <img :src="static_img_url + 'pic/certificate.jpg'" class="certificate-img" />
    </Modal>
  </div>
</template>

<script>
import { getFriendlyLinks } from '@/service/php'
import { mapState } from 'vuex'
export default {
  inject: ['clickBanner'],
  props: {
    btnList: {
      default: () => [],
    },
  },
  data() {
    return {
      certificate_model: false,
      links: [],
    }
  },
  computed: {
    ...mapState({
      static_img_url: (state) => state.static_img_url,
      index2_path: (state) => state.index2_path,
      img_req_url: (state) => state.img_req_url,
      language: (state) => state.language,
    }),
  },
  methods: {
    async getFriendlyLinks() {
      let res = await getFriendlyLinks({}, (error) => {
        this.$Message.error(this.language == 'zh' ? '请求错误！' : 'Request error!')
      })
      if (res.status == 'success') {
        this.$set(this.$data, 'links', res.res)
      } else {
        console.log(res)
      }
    },
  },
  created() {
    this.getFriendlyLinks()
  },
}
</script>

<style lang="stylus" scoped>
.footer
  width 100%
  min-width 1200px
  z-index 100
  .footer-top
    width 1200px
    margin 0 auto
    padding 50px 0 30px
    .content
      display flex
      justify-content space-between
      .left
        .logo
          display block
          width auto
          height 36px
          font-size 0
          &+.p2
            margin-top 90px
        .p2
          font-size 14px
          font-weight 400
          color #333333
          line-height 20px
          &+.p2
            margin-top 20px
      .center
        display flex
        margin-left 100px
        .link
          .link-title
            font-size 16px
            color #333333
            line-height 22px
            font-weight bold
          .link-list
            padding-top 7px
            width 150px
            > div
              margin-top 20px
            a
              font-size 14px
              color #333333
              line-height 20px
              transition all 0.3s
              cursor pointer
              &:hover
                color #FA5A00
      .right
        display flex
        padding-top 40px
        > div
          position relative
          display flex
          .title
            position absolute
            font-size 16px
            color #333333
            line-height 22px
            font-weight 600
            left 0
            top -40px
          &+div
            margin-left 40px
        .ewm-item
          flex 0 0 120px
          display flex
          flex-direction column
          align-items center
          &+div
            margin-left 40px
          img
            width 120px
            height 120px
          p
            font-size 14px
            font-weight 400
            color #6D6D6D
            line-height 20px
            margin-top 10px
            white-space nowrap
    .inter-link
      margin-top 30px
      line-height 1
      .title
        color #333
        font-size 14px
        margin-bottom 0
        font-weight 800
        line-height 1
      .links
        margin-top 15px
        display grid
        grid-template-columns repeat(13, 80px)
        grid-row-gap 10px
        grid-column-gap 10px
        a
          font-size 14px
          margin-right 0
          margin-bottom 0
          color #999
          line-height 1
          width auto
          height 40px
          display flex
          justify-content center
          align-items center
          border 1px solid #e9e9e9
          padding 4px
          border-radius 2px
          cursor pointer
          overflow hidden
          transition all 0.3s
          img
            max-width 100%
            max-height 100%
          &:hover
            border-color #FA5A00
  .footer-bottom
    width 100%
    height 48px
    background #000
    text-align center
    display flex
    align-items center
    justify-content center
    a
      font-size 12px
      color #fff
      display flex
      align-items center
      img
        margin-right 5px
        width 16px
      &+a
        margin-left 20px
      &:hover
        color #FA5A00
.certificate-model
  >>> .ivu-modal-content
    border-radius 0
    .ivu-modal-close
      .ivu-icon-ios-close
        color #fff
    .ivu-modal-body
      padding 0
      font-size 0
.certificate-img
  width 100%
</style>
